const React = require('react');


module.exports = (props) => {
  return (
    <div
      className={'UploadA__Wrapper usN o50.disabled '
        + (props.disabled ? 'disabled ' : '')
        + (props.drag ? 'drag ' : '')
        + (props.className || '')}
    >{props.children}</div>
  );
};
